import React, { Component } from 'react';
import config from 'react-global-configuration';

// Helpers de formulário
import Select from 'react-select';

class ClientFuelRefund extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      flight_types_select: [],
      id: this.props.client_id,
      fuel_refunds_data: this.props.fuel_refunds_data,
    };

    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      id: newProps.client_id,
      fuel_refunds_data: newProps.fuel_refunds_data,
      flight_types_select: newProps.flight_types_select,
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      refund_type: this.state.refund_type,
      flight_type_id: this.state.flight_type_id,
      client_id: this.state.id,
    };
    var self = this;
    var header = self.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cliente/reembolso', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshFuelRefunds(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var client_fuel_refund_id = event;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse reembolso?');
    if (confirm) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = self.props.RequestApi.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/cliente/reembolso/' + client_fuel_refund_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshFuelRefunds(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
    
  render() {
    var self = this;
    return (
<div>
    <form onSubmit={this.add}> 
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <label>Tipo de vôo:</label>
                    <Select
                        className="form-field-name"
                        name="flight_type_id"
                        value={this.state.flight_type_id}
                        searchable={true}
                        placeholder={'Selecionar país'}
                        onChange={this.handleSelectChange.bind(this, 'flight_type_id')}
                        options={this.state.flight_types_select}
                    />    
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <label>Tipo de reembolso:</label>
                    <Select
                        className="form-field-name"
                        name="refund_type"
                        value={this.state.refund_type}
                        searchable={true}
                        placeholder={'Selecionar país'}
                        onChange={this.handleSelectChange.bind(this, 'refund_type')}
                        options={[
                            {value: '1', label: 'Integral'},
                            {value: '2', label: 'Parcial'},
                        ]}
                    />    
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar Reembolso</button>
            </div>
        </div>
    </form>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>Tipo de vôo</th>
          <th>Tipo de reembolso</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
      {typeof self.state.fuel_refunds_data !== 'undefined' && Object.keys(self.state.fuel_refunds_data).map(function(k) {
        var fuel_refund = self.state.fuel_refunds_data[k];
        return (
          <tr>
            <td>{fuel_refund.flight_type}</td>
            <td>{fuel_refund.refund_type_str}</td>
            <td className="text-center">
                <button onClick={() => {self.delete(fuel_refund.id)}} className="btn btn-danger btn-sm button-inline"><i className="fa fa-trash"></i></button>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default ClientFuelRefund;



// WEBPACK FOOTER //
// ./src/Components/Clients/Elements/ClientFuelRefund.js